import request from './request';
import { ENV_CONFIG } from '../config';
import api from '.';

let HTTP_URL = ENV_CONFIG.HTTP_URL;

// 用户接口模块
export default {

	// 首页列表数据
	getRecommendPackageByFeatureCodes(params) {
		return request({
			url   : HTTP_URL + api.getRecommendPackageByFeatureCodes,
			method: 'get',
			params
		});
	},
	
	getMultiSfilterRecordList1(data) {
		return request({
			url   : HTTP_URL + api.getMultiSfilterRecordList1,
			method: 'post',
			data
		});
	},

	getCommercialPackageByFeatureCodes(params) {
		return request({
			url   : HTTP_URL + api.getCommercialPackageByFeatureCodes,
			method: 'get',
			params
		});
	},
    
};
